import { Purchase } from './_Purchase';

export class PreOrder extends Purchase
{
	constructor(form: HTMLFormElement)
	{
		super(form);

		this.Type = "preorder";
	}

	public override BindForm(): void
	{
		super.BindForm();
		this.Form.SubmitHandler = this.AddPreOrderToCart.bind(this);
	}

	public AddPreOrderToCart(): void 
	{
		this.Cart.AddPreOrder(this.Form.Element);
	}
}